<template>
  <Step
    v-if="shouldDisplay"
    :pickers
    :product
    :step
    @clicked="handlePickerClicked"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Prefixes } from '~/scopes/product/components/CustomizationFunnel/components/LargePicker/LargePicker.types'
import { hasPartnerPromoCode } from '~/scopes/product/utils/hasPartnerPromoCode'

import type { Step as StepType } from '../../utils/types'
import Step from '../Step/Step.vue'

import translations from './RakutenStep.translations'

const props = defineProps<{
  product: GetProductResponse
  pickers: GetPickersResponse
}>()

const i18n = useI18n()

const step = ref({
  id: 'rakuten',
  title: i18n(translations.title),
  titleEmphasis: null,
  trackingId: 'rakuten',
  columns: 2,
  options: [
    {
      label: i18n(translations.yesLabel),
      subLabel: i18n(translations.yesDescription),
      available: true,
      selected: true,
      acquirable: true,
      color: null,
      price: undefined,
      trackingValue: 'deactivate',
      style: { prefix: 'Rakuten' as Prefixes },
      value: 'with_rakuten',
    },
    {
      label: i18n(translations.noLabel),
      available: true,
      selected: false,
      acquirable: true,
      color: null,
      price: undefined,
      value: 'without_rakuten',
    },
  ],
  guidance: {
    clickable: true,
    description: i18n(translations.guidanceDescription),
    image: '/img/product/jp/step-rakuten.png',
    label: i18n(translations.guidanceLabel),
    modalName: '',
  },
})

function handlePickerClicked(
  option: StepType['options'][number],
  _step: StepType,
) {
  step.value = {
    ...step.value,
    options: [
      ...step.value.options.map((opt) => ({
        ...opt,
        selected: option.value === opt.value,
      })),
    ],
  }
}

const shouldDisplay = computed(() => {
  return hasPartnerPromoCode(
    props.product?.includedServiceOffers?.partnerPromoCodes,
    'RAKUTEN',
  )
})
</script>
